var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArcadia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 814.67 395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arcadia labs logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M586.28,350.22V238.87h16.06v95.51h25.6v15.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M682.37,315.31l5.22,34.91H671.36l-3.12-20.89h-16.4l-3.18,20.89H632.48l5.22-34.79,11.35-63.62h22Zm-16.23,0-6.13-41-6.13,41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M697.24,251.81H722q21.4,0,21.4,20.71v14.76q0,9.71-8.8,13.73,8.8,4,8.8,13.68v14.87q0,20.6-22.42,20.66H697.24Zm16.06,14V294h5.05a18,18,0,0,0,4.6-.39,6.1,6.1,0,0,0,4.37-6.3V272.52q0-6.75-7-6.75Zm0,42.28V336.2h7q7,0,7-6.64V314.69A6,6,0,0,0,723,308.5a15.71,15.71,0,0,0-4.6-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M755.3,271.1q0-20.66,23-20.66t23.1,20.66v13.23H785.38V271.1q0-6.64-7-6.64h-.12q-6.91,0-6.92,6.64V280q0,6.58,15,16.12t15,22.76v12.43q0,20.71-23,20.71t-23.1-20.71V318.09h16.06v13.23q0,6.65,7,6.64t7-6.64V320.08q0-7.15-15-16.68t-15-23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.27,360.82l19.25-48.69c-24.41,5.36-46.81,8.24-65.24,8.24q-5.61,0-10.57-.36L11.06,395H111.48A25,25,0,0,1,88.27,360.82Zm120.9-169.4h-7.35v55c33.93-15.06,56.45-30.39,67.93-41.76l-25.36-92.12L213.4,0H119.82l-31,112.54L42.43,281.06A82.69,82.69,0,0,0,60,282.64c17.25,0,39-3.2,62.77-9.1l8.6-21.72v-60.4h-7.34a9,9,0,0,1,0-18.1h85.12a9.05,9.05,0,0,1,0,18.1Zm-50.87-89a14.85,14.85,0,1,1,14.85-14.85A14.85,14.85,0,0,1,158.3,102.46Zm23,43a8.2,8.2,0,1,1,8.2-8.2A8.2,8.2,0,0,1,181.35,145.43ZM221.73,395H322.16L279.85,241.32l-1.87,1.3C260.16,254.86,237.55,267,212.15,278l.38,1L245,360.82A25,25,0,0,1,221.73,395Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.71,298.41c8.08,23.17,83.52,17.92,168.5-11.73S316.52,214.21,308.43,191c-3.21-9.22-17.05-13.93-37.89-14.41,8.08,2,13.36,5.35,15.08,10.26,6.85,19.65-46,55.94-118,81.07s-136,29.59-142.83,9.94c-2.7-7.72,3.86-18,17.18-29.23C12.6,267.54-3.67,285.85.71,298.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M406.46,173l6.43,48.61h-20l-3.84-29.06H368.88L365,221.65H345.06l6.43-48.41,14-88.63h27.1Zm-20,0-7.54-57-7.54,57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M424.76,100.53h28.78q26.34,0,26.33,25.5v18.16q0,16-15.57,21.09l22.21,56.37H464.85L447,168.36l-2.51.34v53H424.76Zm19.77,17.19v34.71h4.54a21.53,21.53,0,0,0,5.66-.49q5.37-1.89,5.38-7.75V126q0-8.31-8.6-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M551.47,198.39q0,25.43-28.43,25.5t-28.36-25.5V124.28q0-25.43,28.36-25.42t28.43,25.42v16.28H531.7V124.28q0-8.18-8.59-8.17H523q-8.52,0-8.52,8.17v74.11q0,8.18,8.59,8.17t8.66-8.17V182.12h19.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M622.65,178.69l6.43,43h-20L605.26,196H585.07l-3.91,25.7H561.25l6.43-42.82,14-78.3h27.1Zm-20,0-7.54-50.43-7.55,50.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M641,100.53H671.4q26.34,0,26.34,25.5v70.2q0,25.35-27.59,25.42H641Zm19.77,17.19V204.4h8.66q8.6,0,8.59-8.17V126q0-8.31-8.59-8.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M714.85,100.53h19.77V221.65H714.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M808.24,178.69l6.43,43h-20L790.85,196H770.66l-3.91,25.7H746.84l6.43-42.82,14-78.3h27.1Zm-20,0-7.54-50.43-7.54,50.43Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcadia);
export default __webpack_public_path__ + "static/media/arcadia.40e89a68cfe81f84ee5119ef099f5c4b.svg";
export { ForwardRef as ReactComponent };